import ZContainer from '@/ZForms/parsers/entities/ZEntityContainer';


export default window.ZForms.registerClass('container.card_list', class ZCardListForm extends ZContainer {
  constructor() {
    super(...arguments);
    this.cardFields = [];
    this.cardColorField = null;
  }

  async _updateMetaFromRaw(rawData) {
    await super._updateMetaFromRaw(rawData);
    this.cardFields = rawData.card_fields != null ? rawData.card_fields.map((line) => {
      return line.map((cell) => this.contentMeta.fields[cell]);
    }) : this.cardFields;

    this.cardColorField = rawData.card_color_field != null ? this.contentMeta.fields[rawData.card_color_field] : this.cardColorField;
  }
});
